import { parseNum } from "./dgiiUtils";

// Definición de filas del formulario IT-1 (réplica DGII)
// t: tipo de fila — 'sec' | 'secM' | 'secPen' | 'sub' | 'f' | 'pen' | 'note'
const ROWS = [
  { t: "sec", label: "II. Ingresos por Operaciones", right: "MONTO" },
  { t: "f", n: 1, label: "TOTAL DE OPERACIONES DEL PERIODO (Proviene de la casilla 11 del Anexo A)", op: "+", k: "cas001" },
  { t: "sub", label: "II.A No Gravadas" },
  { t: "f", n: 2, label: "INGRESOS POR EXPORTACIONES DE BIENES SEGUN Art. 342 CT", op: "+", k: "cas002" },
  { t: "f", n: 3, label: "INGRESOS POR EXPORTACIONES DE SERVICIOS SEGUN Art. 344 CT y Art. 14 Lit. j", op: "+", k: "cas003" },
  { t: "f", n: 4, label: "INGRESOS POR VENTAS LOCALES DE BIENES O SERVICIOS EXENTOS Art. 343 y Art. 344 CT", op: "+", k: "cas004" },
  { t: "f", n: 5, label: "INGRESOS POR VENTAS DE BIENES O SERVICIOS EXENTOS POR DESTINO", op: "+", k: "cas005" },
  { t: "f", n: 6, label: "NO SUJETAS A ITBIS POR SERVICIOS DE CONSTRUCCION (Proviene de la casilla 38 del Anexo A)", op: "+", k: "cas006" },
  { t: "f", n: 7, label: "NO SUJETAS A ITBIS POR COMISIONES (Proviene de la casilla 42 del Anexo A)", op: "+", k: "cas007" },
  { t: "f", n: 8, label: "INGRESOS POR VENTAS LOCALES DE BIENES EXENTOS SEGUN Parrafos III y IV, Art. 343 CT", op: "+", k: "cas008" },
  { t: "f", n: 9, label: "TOTAL INGRESOS POR OPERACIONES NO GRAVADAS (Sumar casillas 2+3+4+5+6+7+8)", op: "=", k: "cas009", total: true },
  { t: "sub", label: "II.B Gravadas" },
  { t: "f", n: 10, label: "TOTAL INGRESOS POR OPERACIONES GRAVADAS (Restar casillas 1-9)", op: "=", k: "cas010", total: true },
  { t: "f", n: 11, label: "OPERACIONES GRAVADAS AL 18%", op: "=", k: "cas011" },
  { t: "f", n: 12, label: "OPERACIONES GRAVADAS AL 16%", op: "=", k: "cas012" },
  { t: "f", n: 13, label: "OPERACIONES GRAVADAS AL 9% (Ley No. 690-16)", op: "=", k: "cas013" },
  { t: "f", n: 14, label: "OPERACIONES GRAVADAS AL 8% (Ley No. 690-16)", op: "=", k: "cas014" },
  { t: "f", n: 15, label: "OPERACIONES GRAVADAS POR VENTAS DE ACTIVOS DEPRECIABLES (Categoria 2 y 3)", op: "=", k: "cas015" },
  { t: "note", label: "La sumatoria de las casillas 11+12+13+14+15 debe ser igual al valor de la casilla 10." },
  { t: "sec", label: "III. Liquidación", right: "MONTO" },
  { t: "f", n: 16, label: "ITBIS COBRADO (18% de la casilla 11)", op: "+", k: "cas016", total: true },
  { t: "f", n: 17, label: "ITBIS COBRADO (16% de la casilla 12)", op: "+", k: "cas017", total: true },
  { t: "f", n: 18, label: "ITBIS COBRADO (9% de la casilla 13) (Ley No. 690-16)", op: "+", k: "cas018", total: true },
  { t: "f", n: 19, label: "ITBIS COBRADO (8% de la casilla 14) (Ley No. 690-16)", op: "+", k: "cas019", total: true },
  { t: "f", n: 20, label: "ITBIS COBRADO POR VENTAS DE ACTIVOS DEPRECIABLES (Categoria 2 y 3) (18% de la casilla 15)", op: "+", k: "cas020", total: true },
  { t: "f", n: 21, label: "TOTAL ITBIS COBRADO (Sumar casillas 16+17+18+19+20)", op: "=", k: "cas021", total: true },
  { t: "f", n: 22, label: "ITBIS PAGADO EN COMPRAS LOCALES (Proviene de la casilla 56 del Anexo A)", op: "+", k: "cas022" },
  { t: "f", n: 23, label: "ITBIS PAGADO POR SERVICIOS DEDUCIBLES (Proviene de la casilla 56 del Anexo A)", op: "+", k: "cas023" },
  { t: "f", n: 24, label: "ITBIS PAGADO EN IMPORTACIONES (Proviene de la casilla 56 del Anexo A)", op: "+", k: "cas024" },
  { t: "f", n: 25, label: "TOTAL ITBIS DEDUCIBLE (Sumar casillas 22+23+24)", op: "=", k: "cas025", total: true },
  { t: "f", n: 26, label: "IMPUESTO A PAGAR (Si el valor de las casillas 21-25 es Positivo)", op: "=", k: "cas026", total: true },
  { t: "f", n: 27, label: "SALDO A FAVOR (Si el valor de las casillas 21-25 es Negativo)", op: "=", k: "cas027", total: true },
  { t: "f", n: 28, label: "SALDOS COMPENSABLES AUTORIZADOS (Otros Impuestos) Y/O REEMBOLSOS", op: "+-", k: "cas028" },
  { t: "f", n: 29, label: "SALDO A FAVOR ANTERIOR", op: "-", k: "cas029" },
  { t: "f", n: 30, label: "TOTAL PAGOS COMPUTABLES POR RETENCIONES (Proviene de la casilla 33 del Anexo A)", op: "-", k: "cas030" },
  { t: "f", n: 31, label: "OTROS PAGOS COMPUTABLES A CUENTA", op: "-", k: "cas031" },
  { t: "f", n: 32, label: "COMPENSACIONES Y/O REEMBOLSOS AUTORIZADOS", op: "+", k: "cas032" },
  { t: "f", n: 33, label: "DIFERENCIA A PAGAR (Si el valor de las casillas 26-28-29-30-31-32 es Positivo)", op: "=", k: "cas033", total: true },
  { t: "f", n: 34, label: "NUEVO SALDO A FAVOR (Si el valor de las casillas (26-28-29-30-31-32 es Negativo) o (27+28+29+30+31+32))", op: "=", k: "cas034", total: true },
  { t: "secPen", label: "IV. Penalidades" },
  { t: "pen", n: 35, label: "RECARGOS", pctK: "cas035", op: "+", k: "cas135" },
  { t: "pen", n: 36, label: "INTERES INDEMNIZATORIO", pctK: "cas036", op: "+", k: "cas136" },
  { t: "f", n: 37, label: "SANCIONES", op: "+", k: "cas037" },
  { t: "sec", label: "V. Monto a Pagar", right: "MONTO" },
  { t: "f", n: 38, label: "TOTAL A PAGAR (Sumar casillas 33+35+36+37)", op: "=", k: "cas038", total: true },
  { t: "sec", label: "A. ITBIS Retenido / ITBIS Percibido", right: "MONTO" },
  { t: "f", n: 39, label: "SERVICIOS SUJETOS A RETENCION PERSONAS FISICAS", op: "+", k: "cas039" },
  { t: "f", n: 40, label: "SERVICIOS SUJETOS A RETENCION ENTIDADES NO LUCRATIVAS (Norma No. 01-11)", op: "+", k: "cas040" },
  { t: "f", n: 41, label: "TOTAL SERVICIOS SUJETOS A RETENCION A PERSONAS FISICAS Y ENTIDADES NO LUCRATIVAS", op: "=", k: "cas041", total: true },
  { t: "f", n: 42, label: "SERVICIOS SUJETOS A RETENCION SOCIEDADES (Norma No. 07-09)", op: "=", k: "cas042" },
  { t: "f", n: 43, label: "SERVICIOS SUJETOS A RETENCION SOCIEDADES (Norma No. 02-05 y 07-07)", op: "=", k: "cas043" },
  { t: "f", n: 44, label: "BIENES O SERVICIOS SUJETOS A RETENCION A CONTRIBUYENTES ACOGIDOS AL RST (Operaciones Gravadas al 18%)", op: "+", k: "cas044" },
  { t: "f", n: 45, label: "BIENES O SERVICIOS SUJETOS A RETENCION A CONTRIBUYENTES ACOGIDOS AL RST (Operaciones Gravadas al 16%)", op: "+", k: "cas045" },
  { t: "f", n: 46, label: "TOTAL BIENES O SERVICIOS SUJETOS A RETENCION A CONTRIBUYENTES ACOGIDOS AL RST (Sumar casillas 44+45)", op: "=", k: "cas046", total: true },
  { t: "f", n: 47, label: "BIENES SUJETOS A RETENCION DE COMPROBANTE DE COMPRAS (Operaciones Gravadas al 18%) (Norma No. 05-19)", op: "+", k: "cas047" },
  { t: "f", n: 48, label: "BIENES SUJETOS A RETENCION DE COMPROBANTE DE COMPRAS (Operaciones Gravadas al 16%) (Norma No. 05-19)", op: "+", k: "cas048" },
  { t: "f", n: 49, label: "TOTAL BIENES SUJETOS A RETENCION COMPROBANTES DE COMPRAS (Norma No. 05-19) (Sumar casillas 47+48)", op: "=", k: "cas049", total: true },
  { t: "f", n: 50, label: "ITBIS POR SERVICIOS SUJETOS A RETENCION PERSONAS FISICAS Y ENTIDADES NO LUCRATIVAS (18% de la casilla 41)", op: "+", k: "cas050", total: true },
  { t: "f", n: 51, label: "ITBIS POR SERVICIOS SUJETOS A RETENCION SOCIEDADES (18% de la casilla 42) (Norma No. 07-09)", op: "+", k: "cas051", total: true },
  { t: "f", n: 52, label: "ITBIS POR SERVICIOS SUJETOS A RETENCION SOCIEDADES (18% de la casilla 43 por 0.30) (Norma No. 02-05 y 07-07)", op: "+", k: "cas052", total: true },
  { t: "f", n: 53, label: "ITBIS RETENIDO A CONTRIBUYENTES ACOGIDOS AL RST (18% de la casilla 44)", op: "+", k: "cas053", total: true },
  { t: "f", n: 54, label: "ITBIS RETENIDO A CONTRIBUYENTES ACOGIDOS AL RST (16% de la casilla 45)", op: "+", k: "cas054", total: true },
  { t: "f", n: 55, label: "TOTAL ITBIS RETENIDO A CONTRIBUYENTES ACOGIDOS AL RST (Sumar casillas 53+54)", op: "=", k: "cas055", total: true },
  { t: "f", n: 56, label: "ITBIS POR BIENES SUJETOS A RETENCION DE COMPROBANTE DE COMPRAS (18% de la casilla 47) (Norma No. 05-19)", op: "+", k: "cas056", total: true },
  { t: "f", n: 57, label: "ITBIS POR BIENES SUJETOS A RETENCION DE COMPROBANTE DE COMPRAS (16% de la casilla 48) (Norma No. 05-19)", op: "+", k: "cas057", total: true },
  { t: "f", n: 58, label: "TOTAL POR BIENES SUJETOS A RETENCION DE COMPROBANTE DE COMPRAS (Sumar casillas 56+57)", op: "=", k: "cas058", total: true },
  { t: "f", n: 59, label: "TOTAL ITBIS PERCIBIDO EN VENTA", op: "=", k: "cas059", total: true },
  { t: "f", n: 60, label: "IMPUESTO A PAGAR (Sumar casillas 50+51+52+55+58+59)", op: "=", k: "cas060", total: true },
  { t: "f", n: 61, label: "PAGOS COMPUTABLES A CUENTA", op: "-", k: "cas061" },
  { t: "f", n: 62, label: "DIFERENCIA A PAGAR (Si el valor de las casillas 60-61 es Positivo)", op: "=", k: "cas062", total: true },
  { t: "f", n: 63, label: "NUEVO SALDO A FAVOR (Si el valor de las casillas 60-61 es Negativo)", op: "=", k: "cas063", total: true },
  { t: "secPen", label: "B. Penalidades" },
  { t: "pen", n: 64, label: "RECARGOS", pctK: "cas064", op: "+", k: "cas164" },
  { t: "pen", n: 65, label: "INTERES INDEMNIZATORIO", pctK: "cas065", op: "+", k: "cas165" },
  { t: "f", n: 66, label: "SANCIONES", op: "+", k: "cas066" },
  { t: "sec", label: "C. Monto a Pagar", right: "MONTO" },
  { t: "f", n: 67, label: "TOTAL A PAGAR (Sumar casillas 62+64+65+66)", op: "=", k: "cas067", total: true },
  { t: "f", n: 68, label: "TOTAL GENERAL (Sumar casillas 38+67)", op: "=", k: "cas068", total: true, grand: true },
];

const MoneyInput = ({ value, onChange, readOnly, total, testId }) => (
  <input
    className={`dgii-input ${total ? "total-input" : ""}`}
    value={value || ""}
    readOnly={readOnly}
    onChange={(e) => onChange(e.target.value)}
    onBlur={(e) => {
      const n = parseNum(e.target.value);
      if (e.target.value !== "") {
        onChange(n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      }
    }}
    data-testid={testId}
  />
);

export default function FormularioIT1({ data, onChange, readOnly = false }) {
  const set = (k, v) => onChange({ ...data, [k]: v });

  return (
    <div id="printDocumentit1">
      <div className="dgii-form dgii-print-area">
        <div className="fm-header">
          <div>
            <img
              src="https://www.dasoft.com.do/wp-content/themes/dasoft2.0/image/dasoft-logo.png"
              alt="DGII"
              className="dgii-logo"
              onError={(e) => { e.target.style.display = "none"; }}
            />
          </div>
          <div>
            <h2>DECLARACIÓN JURADA Y/O PAGO DEL IMPUESTO SOBRE LAS TRANSFERENCIAS DE BIENES INDUSTRIALIZADOS Y SERVICIOS (ITBIS)</h2>
          </div>
          <div className="fm-code">
            <h2>IT-1</h2>
            <div>(Valores en RD$)</div>
          </div>
        </div>

        {/* I. Datos Generales */}
        <div className="dgii-header-grid">
          <div className="dgii-field">
            <label>RNC/Cédula</label>
            <input value={data.rnc || ""} readOnly onChange={() => { }} data-testid="it1-rnc" />
          </div>
          <div className="dgii-field">
            <label>Razón social/Nombre</label>
            <input value={data.razon_social || ""} readOnly onChange={() => { }} />
          </div>
          <div className="dgii-field">
            <label>Nombre Comercial</label>
            <input value={data.nombre_comercial || ""} readOnly={readOnly} onChange={(e) => set("nombre_comercial", e.target.value)} />
          </div>
          <div className="dgii-field">
            <label>Correo Electrónico</label>
            <input value={data.correo || ""} readOnly={readOnly} onChange={(e) => set("correo", e.target.value)} />
          </div>
          <div className="dgii-field">
            <label>Teléfono</label>
            <input value={data.telefono || ""} readOnly={readOnly} onChange={(e) => set("telefono", e.target.value)} />
          </div>
          <div className="dgii-field">
            <label>Período Fiscal (Año/Mes)</label>
            <input value={data.periodo || ""} readOnly onChange={() => { }} data-testid="it1-periodo" />
          </div>
          <div className="dgii-field">
            <label>Tipo de Declaración</label>
            <select value={data.tipo_declaracion || ""} disabled={readOnly} onChange={(e) => set("tipo_declaracion", e.target.value)}>
              <option value="">Normal</option>
              <option value="I">Informativa</option>
              <option value="F">Final</option>
            </select>
          </div>
          <div className="dgii-field">
            <label>Rectificativa</label>
            <select value={data.rectificativa || ""} disabled={readOnly} onChange={(e) => set("rectificativa", e.target.value)}>
              <option value="">No</option>
              <option value="C">Si</option>
            </select>
          </div>
        </div>

        <table className="dgii-table" style={{ marginTop: 8 }}>
          <colgroup>
            <col style={{ width: "28px" }} />
            <col />
            <col style={{ width: "22px" }} />
            <col style={{ width: "130px" }} />
          </colgroup>
          <tbody>
            {ROWS.map((row, i) => {
              if (row.t === "sec") {
                return (
                  <tr key={i}>
                    <td className="sec" colSpan={3}>{row.label}</td>
                    <td className="sec" style={{ textAlign: "center" }}>{row.right}</td>
                  </tr>
                );
              }
              if (row.t === "sub") {
                return (
                  <tr key={i}><td className="sec" colSpan={4}>{row.label}</td></tr>
                );
              }
              if (row.t === "secPen") {
                return (
                  <tr key={i}>
                    <td className="sec" colSpan={2}>{row.label}</td>
                    <td className="sec" style={{ textAlign: "center" }}>%</td>
                    <td className="sec" style={{ textAlign: "center" }}>MONTO</td>
                  </tr>
                );
              }
              if (row.t === "note") {
                return (
                  <tr key={i}><td className="lbl" colSpan={4} style={{ fontStyle: "italic" }}>{row.label}</td></tr>
                );
              }
              if (row.t === "pen") {
                return (
                  <tr key={i}>
                    <td className="num">{row.n}</td>
                    <td className="lbl">{row.label}</td>
                    <td className="pct-cell">
                      <input className="dgii-input" style={{ textAlign: "center" }} value={data[row.pctK] || ""} readOnly={readOnly} onChange={(e) => set(row.pctK, e.target.value)} />
                    </td>
                    <td className="money-cell">
                      <MoneyInput value={data[row.k]} onChange={(v) => set(row.k, v)} readOnly={readOnly} testId={`it1-${row.k}`} />
                    </td>
                  </tr>
                );
              }
              // field
              return (
                <tr key={i} style={row.grand ? { backgroundColor: "#99cc66" } : undefined}>
                  <td className="num">{row.n}</td>
                  <td className={`lbl ${row.total ? "total" : ""}`}>{row.label}</td>
                  <td className="op">{row.op}</td>
                  <td className="money-cell">
                    <MoneyInput value={data[row.k]} onChange={(v) => set(row.k, v)} readOnly={readOnly} total={row.total} testId={`it1-${row.k}`} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="dgii-juramento">
          <div className="titulo">JURAMENTO</div>
          <p>
            Declaro bajo la fe de juramento, que los datos consignados en la presente declaración son
            correctos y completos y que no he omitido ni falseado dato alguno que la misma deba contener,
            siendo todo su contenido la fiel expresión de la verdad.
          </p>
        </div>
      </div>
    </div>
  );
}
